<template>
  <div class="overflow-x-auto">
    <table class="TicketsTable StylizedTable">
      <thead>
        <tr>
          <td class="w-sub-pcnt whitespace-no-wrap">
            <v-icon type="ticket"/>
            <span>Билет #</span>
          </td>
          <td
            v-if="showRound"
            class="w-32 whitespace-no-wrap"
          >
            <v-icon type="round"/>
            <span>Тур</span>
          </td>
          <td>
            <v-icon type="odometer"/>
            <span>Километраж</span>
          </td>
          <td
            v-if="showDifference"
            class="w-px"
          >
            <span>Разлика</span>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(ticket) in tickets"
          :key="ticket.id"
        >
          <td class="w-px whitespace-no-wrap">
            <div class="text-grey-darker">{{ ticket.number }}</div>
            <div class="text-sm mt-1">
              <span v-if="ticket.purchased_at">{{ ticket.purchased_at | date }}</span>
            </div>
            <div
              :class="{ 'text-green': ticket.status === 'completed', 'text-dark-red': ticket.status === 'canceled' }"
              class="text-sm opacity-50"
            >
              {{ ticket.status_translated }}
            </div>
          </td>
          <td v-if="showRound">
            <router-link :to="{ name: 'round', params: { id: ticket.round.id } }">
              <div class="text-grey-darker font-bold">{{ ticket.round.name }}
                <v-icon
                  v-if="ticket.round.is_finished"
                  title="Завършен тур"
                  type="check-circle"
                />
                <v-icon
                  v-else
                  title="Активен тур"
                  type="play"
                />
              </div>
              <div>{{ ticket.round.vehicle.full_name }}</div>
            </router-link>
          </td>
          <td class="font-segmented text-3xl md:text-5xl text-right w-48">
            {{ ticket.mileage | mileage }}
          </td>
          <td
            v-if="showDifference"
            class="text-right w-48"
          >
            <div
              v-if="ticket.round.finished_at && ticket.round.mileage"
              class="font-segmented text-5xl"
            >
              {{ ticket.mileage | difference(ticket.round.mileage) }}
            </div>
            <template v-else>
              Турът все още не е завършил
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

/**
 * @module TicketsTable
 */
export default {
  name: 'TicketsTable',
  props: {
    tickets: {
      type: Array,
      default: () => ([])
    },
    showDifference: {
      type: Boolean,
      default: true
    },
    showRound: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style rel='stylesheet/scss' lang='scss'>
@import '~utils';

</style>
